import { channel, eventChannel } from 'redux-saga';
import { all, put, take, delay, takeLatest } from 'redux-saga/effects';

import { safeCall, safeApply } from '../errors';

import { SOCKET_COMMON_CHANNEL } from '../../../consts/socketChannels';

import { WS_CONNECTED, WS_DISCONNECTED } from '../../actions/updates';

import WebSocketConnector from '../../../api/sockets/WebSocketConnector';

import CommonChannelHandler from '../socketHandlers/CommonChannelHandler';

function* watchSocketClose() {
  const channel = eventChannel(emitter => {
    WebSocketConnector.connection.addEventListener('close', () =>
      emitter(WS_DISCONNECTED)
    );
  });

  while (true) {
    const type = yield take(channel);
    yield put({ type });
  }
}

function* watchSocketOpen() {
  const isConnected =
    WebSocketConnector.connection &&
    WebSocketConnector.connection.readyState === WebSocket.OPEN;

  if (!isConnected) {
    const SOCKET_RETRY_TIMEOUT = WebSocketConnector.timeOutConnection;
    yield delay(SOCKET_RETRY_TIMEOUT);
    yield put({ type: WS_DISCONNECTED });
  } else {
    yield put({ type: WS_CONNECTED });
  }
}

function* watchSocketCommonMessage(webSocketConnector, identifier) {
  const socketChannel = channel();
  const commonChannelHandler = new CommonChannelHandler(socketChannel);
  webSocketConnector.subscribeSocketOnMessage({
    identifier,
    socketHandler: commonChannelHandler,
  });

  while (true) {
    const action = yield take(socketChannel);
    yield put(action);
  }
}

function* subscribeSocketCommon() {
  const webSocketConnector = yield safeCall(WebSocketConnector.build);

  const identifier = {
    channel: SOCKET_COMMON_CHANNEL,
  };

  webSocketConnector.subscribeChannel(identifier);

  yield all([
    safeCall(watchSocketCommonMessage, webSocketConnector, identifier),
    safeCall(watchSocketOpen),
  ]);
}

export default function* () {
  yield all([
    safeCall(subscribeSocketCommon),
    takeLatest(WS_CONNECTED, safeApply(watchSocketClose)),
    takeLatest(WS_DISCONNECTED, safeApply(watchSocketOpen)),
  ]);
}
